import { forwardRef } from 'react';
import MaterialTextField, { TextFieldProps } from '@mui/material/TextField';

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(
    (props, ref) => {
        return (
            <MaterialTextField
                ref={ref}
                data-testid={'TextField-container'}
                {...props}
            />
        );
    }
);

export default TextField;
